import { render } from "./PointResourceAssociation.vue?vue&type=template&id=332f9c1e&scoped=true"
import script from "./PointResourceAssociation.vue?vue&type=script&lang=js"
export * from "./PointResourceAssociation.vue?vue&type=script&lang=js"

import "./PointResourceAssociation.vue?vue&type=style&index=0&id=332f9c1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332f9c1e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QList,QItem,QItemSection,QItemLabel,QBanner});qInstall(script, 'directives', {ClosePopup});
